import React, { Component, Fragment } from 'react';
import Alerts from '../../components/alerts';
import Trans from '../../components/transaction/index';
import service from '../../services/replayService';

class ReplayDetails extends Component {

    constructor(props){
        super(props);
        this.state = {
            id: '',
            response: null,
            doReplay: false,
						alerts: [],
        }
    }

    async componentWillMount(){
			try{
        const res = await service.getTransactionById(this.props.match.params.id);
        this.setState({id:this.props.match.params.id, response:res});
        if(!res.id){
					this.setState({alerts: [
						{type:'danger', msg:'Not Found, Please Try Aggain!'}
					]});
        }
			} catch(e) {
				this.setState({alerts: [
					{type:'danger', msg:'Not Found, Please Try Aggain!'}
				]});
			}
    }

    async componentWillReceiveProps(nextProps){
				// clean the state
				try{
					this.setState({ response:null, alerts:[] });
					const res = await service.getTransactionById(nextProps.match.params.id);
					this.setState({id:this.props.match.params.id, response:res});
					if(!res.id){
							this.setState({alerts: [
									{type:'danger', msg:'Not Found, Please Try Aggain!'}
							]});
					}
				} catch(e) {
					console.log(e);
					this.setState({alerts: [
						{type:'danger', msg:'Not Found, Please Try Aggain!'}
					]});
				}
    }

    replay = async () => {
        this.setState({doReplay:true, alerts:[]});
        const res = await service.replayTransaction(this.state.response.id);
        const trans = await service.getTransactionById(this.state.response.id);
        this.setState({
            id:this.props.match.params.id, 
            response:trans, 
            doReplay:false,
            alerts: (res.operation_succesful === 'false')?[{type:'danger', msg:'Replay Fail!'}]:[]
        });
    }

    render() {
        return (
            <Fragment>
							<Alerts alerts={this.state.alerts}/>
							{(this.state.response != null && this.state.response.id)
								?	<Trans 
									response={this.state.response} doReplay={this.state.doReplay} 
									replay={this.replay} />
								: (this.state.response == null && this.state.alerts.length === 0 && <i className={"fas fa-spinner fa-7x fa-spin mt-3"}></i>)
							}
            </Fragment>
        )
    }
}

export default ReplayDetails;
